import { render } from "./HomeFeatures.vue?vue&type=template&id=0904a47d&scoped=true"
import script from "./HomeFeatures.vue?vue&type=script&lang=js"
export * from "./HomeFeatures.vue?vue&type=script&lang=js"

import "./HomeFeatures.vue?vue&type=style&index=0&id=0904a47d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0904a47d"]])

export default __exports__